/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 12:49:50 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import { makeStyles } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core/styles/colorManipulator';
import * as Theme from 'theme';

export const appStyles = makeStyles({
  loading: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: '10%',
    marginLeft: '50%',
  },
  circularProgress: {
    color: 'rgb(60, 70, 87)',
  },
  devCommit: {
    position: 'sticky',
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 0,
    padding: 6,
    backgroundColor: '#efefef',
    textAlign: 'center',
  },
});

export const filterStyle = makeStyles({
  root: {
    marginTop: 0.5,
  },
});

export const dashboardStyles = (backgroundColor = Theme.orange) =>
  makeStyles({
    card: {
      float: 'left',
      margin: '-20px 20px 0 15px',
      zIndex: 100,
      borderRadius: 3,
      backgroundColor,
    },
    icon: {
      float: 'right',
      width: 54,
      height: 54,
      padding: 14,
      color: '#fff',
    },
    flex: { display: 'flex' },
    flexColumn: { display: 'flex', flexDirection: 'column' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em', marginBottom: '2em' },
  })();

export const columnStyles = makeStyles({
  root: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    marginBottom: 10,
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    width: '20vw',
    height: '50%',
    marginRight: 25,
  },
  autoHeightColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '20vw',
    marginRight: 25,
  },
  wideColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '40vw',
    height: '50%',
    marginRight: 25,
  },
  flexGrowColumn: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: '50%',
    marginRight: 25,
  },
  fileUploadContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '40vw',
    fontSize: 14,
  },
  permissionColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '40vw',
    // height: 50,
    marginRight: 25,
    marginLeft: 50,
    maxHeight: '800px',
    flexFlow: 'wrap column',
  },
  permissionColumnContent: { marginTop: 30 },
  lastSiteColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'flex-end',
    height: '75vh',
  },
  lastSiteColumnFields: { minHeight: '75px' },
  centeredMiddleColumnUpper: {
    display: 'flex',
    width: '10vw',
    marginTop: 180,
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    marginRight: 25,
  },
  centeredMiddleColumnLower: {
    display: 'flex',
    width: '10vw',
    marginTop: 265,
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    marginRight: 25,
  },
  loadingMapMessage: {
    marginTop: 50,
    top: '50%',
    left: '50%',
    marginRight: 'auto',
    marginBottom: 0,
    marginLeft: 'auto',
  },
  noUnderline: {
    textDecoration: 'none',
  },
  extendedColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '50%',
    marginRight: 25,
  },
  simpleFormIterator: {
    index: { width: '0' },
    form: { borderColor: 'primary' },
  },
});

export const centeredStyle = makeStyles({
  root: {
    margin: 50,
    marginRight: 'auto',
    marginLeft: 'auto',
    maxHeight: '10em',
  },
});

export const toolbarStyles = makeStyles(theme => ({
  root: {
    flex: 1,
    display: 'flex',
    justifyContent: 'space-between',
  },
  deleteButton: {
    color: theme.palette.error.main,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: alpha(theme.palette.error.main, 0.12),
      // Reset on mouse devices
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
  },
}));

export const tabbedLists = makeStyles({
  root: {
    width: '100%',
  },
  listFilterCreate: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export const tabbedFilters = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
  },
  userTab: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  filterFields: {
    width: '15%',
    marginLeft: 10,
  },
  widerFilterField: {
    width: '30%',
    marginLeft: 10,
  },
  finalFilterField: {
    width: '15%',
    marginLeft: 10,
    marginRight: 10,
  },
});

export const chipList = makeStyles({
  root: {
    margin: 2,
  },
});

export const linkButton = makeStyles({
  root: {
    paddingTop: '0.5%',
    marginTop: '2%',
    height: '6%',
  },
  none: {},
});

export const defaultButton = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      background: theme.palette.primary.dark,
    },
    color: theme.palette.primary.contrastText,
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  icon: {
    fontSize: 18,
  },
}));

export const localeCountryListInputs = makeStyles({
  input: {
    marginBottom: 0,
  },
  helperText: {
    marginLeft: 15,
    marginBottom: 20,
    color: 'red', // use default to match the other helper text
  },
});

export const sideBySide = makeStyles({
  root: {
    flex: 1,
    display: 'flex',
    width: '100%',
  },
  field: { width: '355px', marginRight: 15 },
});

export const tabbedLayoutDatagrid = makeStyles({
  root: {
    paddingBottom: 25,
  },
});

export const inspectionStatusField = textColor =>
  makeStyles({
    root: {
      color: textColor,
      fontWeight: 'bold',
    },
  })();

export const actionButtonStyles = (marginRight = 0) =>
  makeStyles({
    root: {
      paddingBottom: 15,
    },
    approve: {
      color: Theme.white,
      backgroundColor: Theme.green,
      marginRight,
      '&:hover': {
        backgroundColor: Theme.darkenedGreen,
      },
    },
    create: {
      marginTop: 30,
      backgroundColor: Theme.navy,
      '&:hover': {
        backgroundColor: Theme.darkNavy,
      },
    },
    reinspect: {
      color: Theme.white,
      backgroundColor: Theme.amber,
      marginRight,
      '&:hover': {
        backgroundColor: Theme.darkenedAmber,
      },
    },
    decline: {
      color: Theme.white,
      backgroundColor: Theme.red,
      marginRight,
      '&:hover': {
        backgroundColor: Theme.darkenedRed,
      },
    },
    revoke: {
      color: Theme.white,
      backgroundColor: Theme.red,
      marginRight,
      '&:hover': {
        backgroundColor: Theme.darkenedRed,
      },
    },
    checklistImageButton: {
      color: Theme.white,
      marginRight: 5,
      marginLeft: 5,
      backgroundColor: Theme.navy,
      '&:hover': {
        backgroundColor: Theme.darkNavy,
      },
    },
    checklistButton: {
      color: Theme.white,
      marginRight: 5,
      marginLeft: 5,
      backgroundColor: Theme.grey,
      '&:hover': {
        backgroundColor: Theme.lightGrey,
      },
    },
    checklistButtonApproved: {
      color: Theme.white,
      marginRight: 5,
      marginLeft: 5,
      backgroundColor: Theme.green,
      '&:hover': {
        backgroundColor: Theme.darkenedGreen,
      },
    },
    checklistButtonDisapproved: {
      color: Theme.white,
      marginRight: 5,
      marginLeft: 5,
      backgroundColor: Theme.red,
      '&:hover': {
        backgroundColor: Theme.darkenedRed,
      },
    },
    cameraButton: {
      marginRight: 0,
      marginLeft: 0,
      width: 20,
      color: Theme.white,
      backgroundColor: Theme.navy,
      '&:hover': {
        backgroundColor: Theme.darkNavy,
      },
    },
  })();

export const subscriptionTableStyles = (
  marginRight = 0,
  highlightedColor = Theme.lightTurquoise
) =>
  makeStyles({
    currentSubscriptionTop: {
      backgroundColor: highlightedColor,
      borderRadius: '5px 5px 0px 0px',
    },
    currentSubscriptionMiddle: {
      backgroundColor: highlightedColor,
    },
    currentSubscriptionBottom: {
      backgroundColor: highlightedColor,
      borderRadius: '0px 0px 5px 5px',
    },
    noBottomBorder: { borderBottom: 'none' },
    centeredNotification: {
      textAlign: 'center',
      margin: 50,
    },
    cancel: {
      color: Theme.white,
      backgroundColor: Theme.red,
      marginRight,
      '&:hover': {
        backgroundColor: Theme.darkenedRed,
      },
    },
    modalPermissionsList: {
      listStyle: 'none',
      paddingLeft: '0pt',
    },
    confirmModalSubtitle1: {
      marginTop: 15,
    },
    confirmModalSubtitle2: {
      marginTop: 25,
      color: 'red',
    },
    confirmationText: {
      fontWeight: 'bold',
      marginTop: 25,
      marginBottom: 25,
    },
    redirectionLink: {
      fontSize: 'medium',
    },
  })();

export const imageArrayStyles = makeStyles({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  container: {
    '&:hover': {
      '& $image': {
        opacity: 0.3,
      },
      '& $middle': {
        opacity: 1,
      },
    },
  },
  image: {
    height: 200,
    width: 200,
    objectFit: 'cover',
    border: 'thin solid grey',
    borderRadius: 25,
    marginRight: 15,
    opacity: 1,
  },
  middle: {
    transition: '.5s ease',
    position: 'relative',
    left: '47%',
    bottom: '40%',
    transform: 'translate(-50%, -50%)',
    '-ms-transform': 'translate(-50%, -50%)',
    textAlign: 'center',
    opacity: 0,
  },
  text: {
    color: '#474747',
    fontWeight: 'bold',
    fontSize: '16px',
    padding: '16px 32px',
  },
  noImage: {
    margin: 50,
    marginRight: 'auto',
    marginLeft: 'auto',
    maxHeight: '10em',
  },
});

export const modalStyles = makeStyles({
  root: {
    margin: 0,
    left: 8,
    top: 8,
    color: 'red',
  },
  closeButton: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: 'grey',
  },
  content: { padding: 32 },
});

export const accessDeniedStyles = makeStyles(
  theme => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      [theme.breakpoints.up('md')]: {
        height: '100%',
      },
      [theme.breakpoints.down('sm')]: {
        height: '100vh',
        marginTop: '-3em',
      },
    },
    icon: {
      marginTop: 50,
      alignSelf: 'center',
      width: '5em',
      height: '5em',
    },
    message: {
      textAlign: 'center',
      fontFamily: 'Roboto, sans-serif',
      opacity: 0.5,
      margin: '0 1em',
    },
    toolbar: {
      textAlign: 'center',
      marginTop: '2em',
    },
  }),
  { name: 'RaNotFound' }
);
